<template>
    <div>
        <multiselect :clear-on-select="true" v-model="group" :options="clientGroups" selectedLabel="ausgewählt"
                     selectLabel="Klicken zum Hinzufügen" deselectLabel="Klicken zum Entfernen"
                     placeholder="Gruppe auswählen" label="name" track-by="id"></multiselect>
        <button :disabled="!group" type="button" class="btn btn-success" @click="assignToGroup">
            Gruppe zuweisen
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        name: 'GroupOverlay',
        components: {Multiselect},
        props: ['clientGroups', 'chats'],
        data() {
            return {
                group: null,
            }
        },
        methods: {
            assignToGroup: function () {
                this.chats.forEach((chat) => {
                    if (chat.groupId !== this.group.id) {
                        if (chat.status !== 'processed') {
                            this.$store.getters.getFireStore.updateChatGroupId(chat, this.group.id);
                            this.setSuccess('Der Chat von ' + chat.fullCustomerName + ' wurde erfolgreich der Gruppe ' + this.group.name + ' zugewiesen');
                        } else {
                            this.setError('Der Chat von ' + chat.fullCustomerName + ' wird bereits von ' + chat.fullEmployeeName + ' bearbeitet!');
                        }
                    } else {
                        this.setError('Der Chat von ' + chat.fullCustomerName + ' befindet sich bereits in der Gruppe ' + this.group.name);
                    }
                });
                this.removeChatsFromOverview(this.chats);
                this.closeOverlay();
            },
            removeChatsFromOverview(chats) {
                this.$emit('update-chats', chats)
            },
            closeOverlay: function () {
                this.$emit('closeOverlay');
            },
            setSuccess(msg) {
                this.$emit('success', msg);
            },
            setError(msg) {
                this.$emit('error', msg);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .groupoverlay {
        display: flex;
        justify-content: space-between;
        margin: 150px auto 30px;
        position: absolute;
        z-index: 100;
        width: 460px;
        background: #fffffe;
        border-radius: 15px;
        padding: 50px 10px 100px;
        box-shadow: 0 7px 15px 5px rgba(0, 0, 0, 0.1);
        right: 10%;
    }

    button {
        bottom: 10%;
    }

    .media-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999999;
        transition: all 0.5s;
        opacity: 0;
        pointer-events: none;

        &__icon {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
            background: #fff;
            box-shadow: 0 5px 5px rgba(0, 0, 0, 0.15);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: translate(50%, -50%);
            color: #333;
            cursor: pointer;
        }

    }

    .multiselect {
        margin: 20px 0 20px 0;
    }

    @keyframes spinning {
        0% {
            transform: rotate(0)
        }
        to {
            transform: rotate(2turn)
        }
    }
</style>
